module.exports = __webpack_public_path__ + "4afbaa6fc2c3e0926ca35f740e30362e.svg";